import { createContext, useContext } from "react";

/** Whether the tooltips below are lazy by default. Set by `LazyTooltipScope`; false everywhere else. */
export const LazyTooltipScopeContext = createContext(false);

export const useLazyTooltipScope = (): boolean => useContext(LazyTooltipScopeContext);
